// eslint-disable-next-line import/prefer-default-export
export const SMTP_SETTINGS_DOCUMENTATION_URL = 'https://dropsuite.atlassian.net/wiki/x/AQCjbg';
